<div class="warranty-assign-modal">
  <!-- Start header -->
  <div class="warranty-header flex-between-center">
    <span class="header-title flex-start-center gap-2">
      <i class="fas fa-exclamation-triangle font-14 font-900"></i>
      <span class="font-18 font-600">
        Assign Warranty
        <span *ngIf="itemName"> - {{itemName}}</span>
      </span>
    </span>

    <span class="pointer" (click)="handleDiscardChanges()">
      <i class="fa fa-times font-18 font-300"></i>
    </span>
  </div>
  <!-- End header -->

  <!-- Start body -->
  <div class="warranty-body" [ngClass]="{'flex-start': !isLoading, 'flex-center-center': isLoading}">
    <ng-container *ngIf="!isLoading">
      <div class="warranty-group-wrapper flex-start width-100p no-scroll">
        <div *ngIf="isShowMultipleAssignView" class="width-20p warranty-unassiged flex-column">
          <ng-container *ngFor="let service of unassignedServices; let serviceIdx = index;">
            <div class="service-separator border-top" *ngIf="serviceIdx > 0"></div>

            <span class="service-title font-14 font-600 capitalize">{{service?.title || service?.titleFR}}</span>
            <div class="flex-start-center w-100 pointer" *ngFor="let item of service?.items; let itemIdx = index;"
              (click)="setNextSelectedItem(item)">
              <div class="flex-column width-90p" [ngClass]="{
                'service-item-card-secondary': skippedItems[item?.itemId]?.isSkipped,
                'service-item-card-selected': selectedItem?.itemId === item?.itemId,
                'service-item-card-error': !skippedItems[item?.itemId]?.isSkipped && selectedItem?.itemId !== item?.itemId
              }">
                <div class="flex-between-center">
                  <span class="type-badge flex-start">
                    <i class="flex-start-center" [ngClass]="iconMap[item?.type]"></i>
                    <span class="item-type">{{typeMap[item?.type]}}</span>
                  </span>
                  <i *ngIf="skippedItems[item?.itemId]?.isSkipped"
                    class="far fa-exclamation-triangle font-14 font-400"></i>
                </div>

                <span class="item-title font-14 font-600 text-truncate">{{item?.title || item?.titleFR}}</span>
              </div>
              <div *ngIf="selectedItem?.itemId === item?.itemId" class="selected-seperator"></div>
            </div>
          </ng-container>
        </div>

        <!-- warranty group section -->
        <div class="h-100 w-100" [ngClass]="{
            'highlighter-border': selectedItem?.itemId
            }">
          <!-- warranty code section -->
          <div class="warranty-wrapper flex-start flex-column pr-0">
            <!-- warranty group details card-->
            <div class="warranty-wrapper-body no-scroll flex-column pr-2"
              [ngClass]="{'row-direction': selectedItem?.isWarrantyReplacementType }">
              <ng-container>
                <div class="warranty-group-detail-card flex-column">
                  <a class="detail-header">
                    <span class="group-title-code font-14 font-600">
                      <span class="group-code">Warranty Types</span>
                    </span>
                  </a>
                  <ng-container *ngFor="let item of groupedResults; let itemIndex = index;">
                    <div class="warranty-detail-body flex-column">
                      <div class="warranty-detail font-14 font-400 pointer" (click)="handleSelect(item, itemIndex)"
                        [ngClass]="{'active': item.warrantyType === 'replacement' &&
                        selectedItem?.isWarrantyReplacementType }">
                        <ng-container>
                          <span class="warranty">
                            {{item._id}}
                          </span>
                          <span class="warranty">&nbsp;-&nbsp;</span>
                          <span class="warranty">
                            {{item.title}}
                          </span>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                </div>

                <div class="assign-warranty-body warranty-group-detail-card flex-column width-77p"
                  *ngIf="selectedItem?.isWarrantyReplacementType">
                  <a class="detail-header">
                    <span class="group-title-code font-14 font-600">
                      <span class="group-code">Warranty Replacement Information</span>
                    </span>
                  </a>
                  <ng-container>
                    <div class="warranty-detail-body flex-column">
                      <div class="warranty-code-detail font-14 font-400 pointer">
                        <!-- being replace section -->
                        <div class="flex-column warranty-inner-replaced mb-2">
                          <div class="flex-row">
                            <app-radio-button [selectedValue]="warrantyEligible?.partWarrantyType"
                              name="partWarrantyType" styleClassLabel="font-14 font-600"
                              label="Select part being replaced" value="being-replaced"
                              [disabled]="warrantyEligible?.disableHistory"
                              (appChange)="handleChange('partWarrantyType', $event)"></app-radio-button>
                          </div>
                          <div class="flex-row warranty-parts">
                            <div class="flex-column warranty-parts-section w-100">
                              <!-- Table header -->
                              <div class="flex-row warranty-table-row">
                                <span class="ui-g-3 font-14 font-700">
                                  <!-- {{typeMap[item?.type] ? 'Part':'Tire'}} -->
                                  {{selectedItem?.type === 'tire' ? 'Tire' : 'Part'}}&nbsp;Name</span>
                                <span class="ui-g-2 font-14 font-700">Part #</span>
                                <span class="ui-g-2 font-14 font-700" *ngIf="isWarrantyNumberAddonEnabled">Warranty
                                  #</span>
                                <span class="ui-g-2 font-14 font-700">Repair Order #</span>
                                <span class="ui-g-2 font-14 font-700">Invoice Date</span>
                                <span class="ui-g-2 font-14 font-700"></span>
                              </div>
                              <!-- Table rows -->
                              <div class="flex-row warranty-table-row"
                                *ngFor="let partHistory of partWarrantiesHistory">
                                <span class="ui-g-3 font-14 font-400 text-truncate" tooltipPosition="top"
                                  [pTooltip]="partHistory?.partName">{{partHistory?.partName}}</span>
                                <span class="ui-g-2 font-14 font-400 text-truncate" tooltipPosition="top"
                                  [pTooltip]="partHistory?.partNumber">{{partHistory?.partNumber}}</span>
                                <span class="ui-g-2 font-14 font-400 text-truncate" tooltipPosition="top"
                                  [pTooltip]="partHistory?.warrantyNumber"
                                  *ngIf="isWarrantyNumberAddonEnabled">{{partHistory?.warrantyNumber}}</span>
                                <span class="ui-g-2 font-14 font-400 ">RO # {{partHistory?.code}}</span>
                                <span class="ui-g-2 font-14 font-400">{{partHistory?.invoiceDate | date : 'MMM d,
                                  yyyy'}}</span>
                                <span class="ui-g-2 font-14 font-400 p-0 flex-center-start">
                                  <button class="btn btn-white btn-submit"
                                    [disabled]="warrantyEligible?.partWarrantyType !== 'being-replaced'"
                                    [ngClass]="{'btn-selected': partHistory?._id === warrantyEligible?.selectedPart?._id, 'not-allowed': warrantyEligible?.partWarrantyType !== 'being-replaced'}"
                                    (click)="selectUnSelectPart(partHistory)">
                                    <span class="font-700 font-14">{{ partHistory?._id ===
                                      warrantyEligible?.selectedPart?._id ? 'Selected' : 'Select'}}</span>
                                  </button>
                                </span>
                              </div>

                              <div class="warranty-table-row flex-center-center no-matching-ins"
                                *ngIf="!partWarrantiesHistory?.length">No matching warranty installations</div>
                            </div>
                          </div>
                        </div>

                        <!-- manually entered warranty -->
                        <div class="flex-column warranty-inner-replaced">
                          <div class="flex-row" *ngIf="isWarrantyNumberAddonEnabled">
                            <app-radio-button [selectedValue]="warrantyEligible?.partWarrantyType"
                              name="partWarrantyType" styleClassLabel="font-14 font-600"
                              label="Manually enter Warranty #" value="manually-entered"
                              (appChange)="handleChange('partWarrantyType', $event)"></app-radio-button>
                          </div>
                          <app-manual-enter-warranty [isWarrantyNumberAddonEnabled]="isWarrantyNumberAddonEnabled"
                            [warrantyEligible]="warrantyEligible" openFrom="merge-prompt" [error]="error"
                            styleClass="p-0" [data]="{
                          itemId: this.currentItemId,
                          customerId: this.customerId,
                          vehicleId: this.vehicleId
                      }" (warrantySave)="handleManualWarranty($event)"></app-manual-enter-warranty>
                        </div>

                      </div>

                      <div class="ui-g-6"
                        *ngIf="warrantyEligible?.warrantyType === 'replacement' && isWarrantyPartType">
                        <app-checkbox inputId="set-price-cost-zero" label="Set Cost and Price to $0.00"
                          [isChecked]="warrantyEligible?.isSetCostPriceZero" [greenCheckbox]="true"
                          [disabled]="invoicedRO" (appChange)="handleChange('isSetCostPriceZero', $event)">
                        </app-checkbox>
                      </div>
                      <div class="ui-g-6"
                        *ngIf="warrantyEligible?.warrantyType === 'replacement' && !isWarrantyPartType">
                        <app-checkbox inputId="set-price-cost-zero" label="Set Price to $0.00" [disabled]="invoicedRO"
                          [isChecked]="warrantyEligible?.isSetPriceZeroOnly" [greenCheckbox]="true"
                          (appChange)="handleChange('isSetPriceZeroOnly', $event)">
                        </app-checkbox>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

    </ng-container>
    <i class="fa fa-spinner rotate font-20" *ngIf="isLoading"></i>
  </div>
  <!-- End body -->

  <!-- Start footer -->
  <div *ngIf="isShowMultipleAssignView" class="warranty-footer flex-end-center gap-2 border-top-lightest">
    <button class="btn btn-custom-white btn-width btn-submit" (click)="setSkippedItems(selectedItem)">Skip</button>
    <button class="btn btn-primary btn-width btn-submit" [disabled]="isSubmitting" (click)="handleSaveAndExit()">
      Save &amp; Exit
      <i class="fa fa-spinner rotate ml-1" *ngIf="isSubmitting"></i>
    </button>
  </div>
  <!-- End footer -->
</div>